import toastReducer from "./reducer"

const saga = {
  reducers: toastReducer
}

export default saga